type ClientParam = {
  code: string;
  name: string;
  logo: string;
  favicon: string;
};

export const useClientDomainParam = (): ClientParam => {
  const domain = process.env.REACT_APP_FRONT_ENDPOINT?.replace(/.*\//, '') || '';
  const hostName = window.location.hostname;
  const urlParams = hostName !== domain ? hostName.match(/^(.*?)\./) : [];
  const clientCode = urlParams?.[1] || 'shin-create';
  const clientParamCode = clientCode.replace(/-/g, '_').toUpperCase();
  const clientParam: Partial<ClientParam> = JSON.parse(process.env[`REACT_APP_CLIENT_${clientParamCode}`] || '{}');

  return {
    code: clientCode,
    name: clientParam.name || '',
    logo: clientParam.logo || `${clientCode}.svg`,
    favicon: clientParam.favicon || `${clientCode}.favicon.ico`,
  };
};